import APITemplate from '@/api/APITemplate'

const url = '/api/feedback'

const template = APITemplate(url)
export default {
  ...template,
}
